import { useEffect, useState } from "react";

/**
 * True when the window is too short for the full layout -- Discord's
 * picture-in-picture, or a phone held sideways.
 *
 * The same 430px threshold as the CSS. Kept in sync by hand rather than read
 * back from the stylesheet: two numbers is a smaller risk than a lookup that
 * silently returns nothing.
 */
export const COMPACT_QUERY = "(max-height: 430px)";

export function useCompact(): boolean {
  const [compact, setCompact] = useState(
    () => typeof window !== "undefined" && window.matchMedia(COMPACT_QUERY).matches,
  );

  useEffect(() => {
    const query = window.matchMedia(COMPACT_QUERY);
    const update = () => setCompact(query.matches);
    update();
    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, []);

  return compact;
}
